/**
 * English locale catalogs for the host app layer.
 *
 * These messages live at the host scope (above feature folders) because
 * they back the nav descriptors and `document.title` translations owned
 * by `app/nav.ts` and `app/router.ts`. The matching Russian catalog in
 * `./ru.ts` must satisfy `typeof appHostEn` exactly.
 */
export const appHostEn = {
  /**
   * Labels rendered inside the primary nav strip. Each entry maps a nav
   * descriptor's `key` (the route name) to its display label. Keep these
   * in sync with the keys used in `gvgPlannerNavLinks()`.
   */
  nav: {
    calendar: 'Calendar',
    raidPlan: 'Raid plan',
    officers: 'Guild settings',
    auditLog: 'Audit log',
    onboarding: 'Onboarding',
    myBuilds: 'Manage my builds',
  },
  /**
   * Labels rendered inside the header profile popover (the "Manage my
   * builds" quick-link surfaces here).
   */
  profilePopover: {
    myBuilds: 'Manage my builds',
  },
  /**
   * Browser-tab titles (`document.title`) for every named route. Keys are
   * the route `name` strings (FEATURE_ROUTE_NAMES / APP_ROUTE_NAMES).
   * The host router appends `· WWM GvG` after the resolved title.
   */
  routeTitle: {
    calendar: 'Calendar',
    'gvg-planner': 'GvG Planner',
    officers: 'Guild settings',
    'audit-log': 'Audit log',
    onboarding: 'Onboarding',
    'my-builds': 'My builds',
    'not-found': 'Not found',
  },
} as const
